import React from 'react';
import useButtonState, {ApiDynamicButtonProps} from './state';
import CircleButton from '../circle-button';

const ApiDynamicButton: React.FC<ApiDynamicButtonProps> = (props) => {
  const {isLoading, handleRequest} = useButtonState(props);

  return (
    <CircleButton
      tooltip={props.button.tooltip}
      icon={props.button.icon}
      onClick={(e: Event) => {
        handleRequest();
        e.stopPropagation();
      }}
      loading={isLoading}
    />
  );
};

export default ApiDynamicButton;
